import { Tabs as TabsA } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';

export type TabsProperties = {
  hasContentHolderHidden?: boolean;
} & ComponentProps<typeof TabsA>;

const Tabs = ({ className, hasContentHolderHidden, type, ...rest }: TabsProperties) => (
  <TabsA
    className={cn(className, 'ui-tabs', {
      'ui-tabs--content-holder-hidden': hasContentHolderHidden,
    })}
    {...rest}
  />
);

export default Tabs;
